(function() {
  'use strict';
 
  if (!document.body.classList.contains('template-product')) return;
 
  const CONFIG = {
    buttonEnableDelay: 1500,
    variantCheckInterval: 50,
    maxWaitTime: 2000,
    customElementWaitTime: 2000,
    enableLogging: false
  };
 
  function log(message, data) {
    if (CONFIG.enableLogging && typeof console !== 'undefined') {
      if (data !== undefined) {
        console.log(message, data);
      } else {
        console.log(message);
      }
    }
  }
 
  let variantSelectorReady = false;
  let protectionActive = false;
  let expectedVariantId = null;
  let pendingSubmission = false;
  let lastSelectedVariantId = null;
 
  function initVariantProtection() {
    try {
      log('Variant Protection: Initializing...');
     
      const productForms = document.querySelectorAll('product-form form[action*="/cart/add"]');
     
      if (productForms.length === 0) {
        log('WARNING: No product forms found');
        return;
      }
     
      productForms.forEach(function(form) {
        waitForVariantRadios(form, function() {
          protectForm(form);
        });
      });
     
    } catch (error) {
      log('ERROR: Init error:', error);
    }
  }
 
  function waitForVariantRadios(form, callback) {
    const startTime = Date.now();
   
    function checkForRadios() {
      const radioButtons = form.querySelectorAll(
        'input[type="radio"][name="Size"], ' +
        'input.product-form__radio, ' +
        'variant-radios input[type="radio"]'
      );
     
      if (radioButtons.length > 0) {
        log('SUCCESS: Found', radioButtons.length, 'radio buttons');
        callback();
        return;
      }
     
      const elapsed = Date.now() - startTime;
      if (elapsed > CONFIG.customElementWaitTime) {
        log('WARNING: Timeout waiting for radio buttons, proceeding anyway');
        callback();
        return;
      }
     
      setTimeout(checkForRadios, 100);
    }
   
    checkForRadios();
  }
 
  function protectForm(form) {
    try {
      log('SUCCESS: Protecting form');
     
      const hiddenVariantInput = form.querySelector('input[name="id"]');
      const variantSelect = form.querySelector('select[name="id"]');
     
      let optionInputs = form.querySelectorAll(
        'input[type="radio"][name="Size"], ' +
        'input[type="radio"][name="Color"], ' +
        'input.product-form__radio'
      );
     
      if (optionInputs.length === 0) {
        log('INFO: No inputs in form, trying document query');
        optionInputs = document.querySelectorAll(
          'variant-radios input[type="radio"], ' +
          '.product-form__radio'
        );
      }
     
      log('INFO: Found selectors:', {
        totalOptions: optionInputs.length,
        hidden: !!hiddenVariantInput,
        select: !!variantSelect
      });
     
      optionInputs.forEach(function(input, index) {
        log('SELECTOR ' + index + ':', {
          name: input.name,
          value: input.value,
          checked: input.checked,
          variantId: input.getAttribute('data-variant-id')
        });
      });
     
      const initialVariantId = getVariantIdFromUrl() ||
                              (hiddenVariantInput ? hiddenVariantInput.value : null) ||
                              (variantSelect ? variantSelect.value : null);
     
      expectedVariantId = initialVariantId;
      lastSelectedVariantId = initialVariantId;
     
      log('INFO: Initial variant ID:', initialVariantId);
      log('INFO: Initial URL:', window.location.href);
     
      setupOptionTracking(form, optionInputs, hiddenVariantInput);
     
      const atcButtons = setupButtonProtection(form);
     
      setupSubmissionProtection(form, hiddenVariantInput, variantSelect, optionInputs);
     
      const enableTimeout = setTimeout(function() {
        enableButtons(atcButtons);
        variantSelectorReady = true;
        protectionActive = true;
        log('SUCCESS: Auto-enabled after delay');
      }, CONFIG.buttonEnableDelay);
     
      form.addEventListener('change', function() {
        if (!protectionActive) {
          clearTimeout(enableTimeout);
          enableButtons(atcButtons);
          protectionActive = true;
          variantSelectorReady = true;
          log('SUCCESS: Early enabled');
        }
      }, { once: true });
     
    } catch (error) {
      log('ERROR: Form protection error:', error);
    }
  }
 
  function getVariantIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
  }
 
  function setupOptionTracking(form, optionInputs, hiddenVariantInput) {
    try {
      let variantUpdatePending = false;
     
      document.addEventListener('change', function(e) {
        const target = e.target;
        if (target && target.type === 'radio' && target.name === 'Size') {
          variantUpdatePending = true;
         
          const dataVariantId = target.getAttribute('data-variant-id');
         
          if (dataVariantId) {
            expectedVariantId = dataVariantId;
            log('CHANGE: Size selected:', target.value, 'Expected variant:', dataVariantId);
            log('STATUS: Variant update PENDING (waiting for Ella theme)');
          }
        }
      }, true);
     
      if (hiddenVariantInput) {
        hiddenVariantInput.addEventListener('change', function(e) {
          if (variantUpdatePending) {
            lastSelectedVariantId = hiddenVariantInput.value;
            variantSelectorReady = true;
            variantUpdatePending = false;
           
            log('CHANGE: Hidden input updated by Ella:', hiddenVariantInput.value);
            log('STATUS: Variant update COMPLETE - ready for submission');
          }
        }, false);
       
        if (typeof MutationObserver !== 'undefined') {
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                const newValue = hiddenVariantInput.value;
                if (newValue && newValue !== mutation.oldValue) {
                  lastSelectedVariantId = newValue;
                  expectedVariantId = newValue;
                 
                  if (variantUpdatePending) {
                    variantUpdatePending = false;
                    log('MUTATION: Hidden input updated:', newValue);
                    log('STATUS: Variant update COMPLETE');
                  }
                }
              }
            });
          });
         
          observer.observe(hiddenVariantInput, {
            attributes: true,
            attributeOldValue: true
          });
        }
      }
     
      optionInputs.forEach(function(input) {
        if (!input) return;
       
        input.addEventListener('change', function(e) {
          variantSelectorReady = true;
          variantUpdatePending = true;
         
          const dataVariantId = e.target.getAttribute('data-variant-id');
         
          if (dataVariantId) {
            expectedVariantId = dataVariantId;
            log('CHANGE: Direct listener - Size:', e.target.value, 'Variant:', dataVariantId);
          }
        }, true);
      });
     
    } catch (error) {
      log('ERROR: Option tracking error:', error);
    }
  }
 
  function setupButtonProtection(form) {
    try {
      const atcButtons = form.querySelectorAll(
        'button[type="submit"][name="add"],' +
        'button.productView-btn-cart,' +
        '.product-form__submit,' +
        'button[data-add-to-cart]'
      );
     
      atcButtons.forEach(function(button) {
        if (!button) return;
       
        button.disabled = true;
        button.classList.add('is-loading');
       
        if (!button.dataset.originalText) {
          button.dataset.originalText = button.textContent ? button.textContent.trim() : 'Add to cart';
        }
       
        log('LOCKED: Button remains disabled (inline script already disabled it)');
      });
     
      return atcButtons;
     
    } catch (error) {
      log('ERROR: Button protection error:', error);
      return [];
    }
  }
 
  function enableButtons(buttons) {
    try {
      buttons.forEach(function(button) {
        if (!button) return;
       
        button.disabled = false;
        button.classList.remove('is-loading');
        button.style.opacity = '';
        button.style.cursor = '';
       
        if (button.dataset.originalText) {
          button.textContent = button.dataset.originalText;
        }
      });
    } catch (error) {
      log('ERROR: Button enable error:', error);
    }
  }
 
  function setupSubmissionProtection(form, hiddenVariantInput, variantSelect, optionInputs) {
    try {
      form.addEventListener('submit', handleSubmit, true);
     
      const originalFetch = window.fetch;
      window.fetch = function(url, options) {
        if (url && url.includes('/cart/add')) {
          log('INTERCEPT: Fetch to /cart/add detected');
          return validateAndFetch(url, options, originalFetch, hiddenVariantInput);
        }
        return originalFetch.apply(this, arguments);
      };
     
      function handleSubmit(e) {
        log('SUBMIT: Form submission intercepted');
       
        if (!variantSelectorReady) {
          e.preventDefault();
          e.stopImmediatePropagation();
          log('BLOCKED: Selector not ready');
         
          if (typeof alert !== 'undefined') {
            alert('Please wait a moment while the page loads, then try again.');
          }
          return false;
        }
       
        const currentVariantId = hiddenVariantInput ? hiddenVariantInput.value :
                                 variantSelect ? variantSelect.value : null;
       
        log('CHECK: Submission check:', {
          currentVariantId: currentVariantId,
          lastSelected: lastSelectedVariantId,
          expected: expectedVariantId
        });
       
        const checkedRadio = document.querySelector('input[name="Size"]:checked');
        if (checkedRadio) {
          const checkedVariantId = checkedRadio.getAttribute('data-variant-id');
          log('CHECK: Checked radio:', checkedRadio.value, 'Variant:', checkedVariantId);
         
          if (checkedVariantId && currentVariantId !== checkedVariantId) {
            e.preventDefault();
            e.stopImmediatePropagation();
            log('BLOCKED: Mismatch - Checked:', checkedVariantId, 'Hidden:', currentVariantId);
           
            if (pendingSubmission) {
              return false;
            }
           
            pendingSubmission = true;
            waitForVariantSync(form, checkedVariantId, hiddenVariantInput);
            return false;
          }
        }
       
        if (lastSelectedVariantId && lastSelectedVariantId !== currentVariantId) {
          e.preventDefault();
          e.stopImmediatePropagation();
          log('BLOCKED: Last selected mismatch');
         
          if (pendingSubmission) {
            return false;
          }
         
          pendingSubmission = true;
          waitForVariantSync(form, lastSelectedVariantId, hiddenVariantInput);
          return false;
        }
       
        log('SUCCESS: Submission allowed with variant:', currentVariantId);
      }
     
      function validateAndFetch(url, options, originalFetch, hiddenInput) {
        const currentVariantId = hiddenInput ? hiddenInput.value : null;
       
        const checkedRadio = document.querySelector('input[name="Size"]:checked');
        const checkedVariantId = checkedRadio ? checkedRadio.getAttribute('data-variant-id') : null;
       
        log('AJAX CHECK: Hidden input variant:', currentVariantId);
        log('AJAX CHECK: Checked radio variant:', checkedVariantId);
        log('AJAX CHECK: Last selected variant:', lastSelectedVariantId);
       
        if (checkedVariantId && currentVariantId !== checkedVariantId) {
          log('AJAX BLOCKED: Checked radio mismatch - ABORTING original request');
         
          return new Promise(function(resolve, reject) {
            const startTime = Date.now();
            const maxWait = CONFIG.maxWaitTime;
           
            const checkInterval = setInterval(function() {
              const newVariantId = hiddenInput ? hiddenInput.value : null;
              const elapsed = Date.now() - startTime;
             
              if (newVariantId === checkedVariantId) {
                clearInterval(checkInterval);
                log('AJAX RETRY: Variant synced after', elapsed, 'ms - creating new request');
               
                const newOptions = createNewRequest(options, checkedVariantId);
                resolve(originalFetch(url, newOptions));
                return;
              }
             
              if (elapsed > maxWait) {
                clearInterval(checkInterval);
                log('AJAX TIMEOUT: Creating NEW request with correct variant after', elapsed, 'ms');
               
                const newOptions = createNewRequest(options, checkedVariantId);
                resolve(originalFetch(url, newOptions));
                return;
              }
             
              if (elapsed % 200 === 0) {
                log('AJAX WAIT: Still waiting...', elapsed, 'ms');
              }
            }, 50);
          });
        }
       
        if (lastSelectedVariantId && currentVariantId !== lastSelectedVariantId) {
          log('AJAX BLOCKED: Last selected mismatch - ABORTING original request');
         
          return new Promise(function(resolve) {
            const startTime = Date.now();
            const maxWait = CONFIG.maxWaitTime;
           
            const checkInterval = setInterval(function() {
              const newVariantId = hiddenInput ? hiddenInput.value : null;
              const elapsed = Date.now() - startTime;
             
              if (newVariantId === lastSelectedVariantId) {
                clearInterval(checkInterval);
                log('AJAX RETRY: Variant synced to last selected after', elapsed, 'ms');
               
                const newOptions = createNewRequest(options, lastSelectedVariantId);
                resolve(originalFetch(url, newOptions));
                return;
              }
             
              if (elapsed > maxWait) {
                clearInterval(checkInterval);
                log('AJAX TIMEOUT: Proceeding with current:', newVariantId);
                resolve(originalFetch(url, options));
                return;
              }
             
              if (elapsed % 200 === 0) {
                log('AJAX WAIT: Still waiting...', elapsed, 'ms');
              }
            }, 50);
          });
        }
       
        log('AJAX ALLOWED: Proceeding with original request');
        return originalFetch(url, options);
      }
     
      function createNewRequest(originalOptions, correctVariantId) {
        log('CREATE: Building fresh request with variant:', correctVariantId);
       
        try {
          const newOptions = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: correctVariantId,
              quantity: 1
            })
          };
         
          log('CREATE: New request body:', newOptions.body);
          return newOptions;
         
        } catch (error) {
          log('ERROR: Could not create new request:', error);
          return originalOptions;
        }
      }
     
    } catch (error) {
      log('ERROR: Submission protection error:', error);
    }
  }
 
  function waitForVariantSync(form, targetVariantId, hiddenInput) {
    const startTime = Date.now();
    log('WAIT: Syncing to variant:', targetVariantId);
   
    const checkInterval = setInterval(function() {
      const currentVariantId = hiddenInput ? hiddenInput.value : null;
      const elapsed = Date.now() - startTime;
     
      if (currentVariantId === targetVariantId) {
        clearInterval(checkInterval);
        pendingSubmission = false;
        log('SUCCESS: Variant synced');
       
        try {
          form.submit();
        } catch(error) {
          log('ERROR: Submit failed:', error);
        }
        return;
      }
     
      if (elapsed > CONFIG.maxWaitTime) {
        clearInterval(checkInterval);
        pendingSubmission = false;
        log('TIMEOUT: Submitting anyway');
       
        try {
          form.submit();
        } catch(error) {
          log('ERROR: Submit failed:', error);
        }
        return;
      }
     
      if (elapsed % 200 === 0) {
        log('WAIT: Current:', currentVariantId, 'Target:', targetVariantId);
      }
     
    }, CONFIG.variantCheckInterval);
  }
 
  var initialized = false;
 
  function safeInit() {
    if (!initialized) {
      initialized = true;
      initVariantProtection();
    }
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
 
})();
